module.exports = __webpack_public_path__ + "1c_fran_red.47accec723728e6b0e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1c_fran_red.png
// module id = 27
// module chunks = 2